import { Eyebrow } from "../common/Primitives";
import { Reveal, Stagger, StaggerItem } from "../motion/Reveal";
import { LabResults } from "./LabResults";

const PILLARS = [
  { t: "Hydration as hospitality", d: "Good water is the most universal courtesy a property can offer — at the bedside, the table and the spa." },
  { t: "A smooth, clean taste", d: "Our formulation is being developed for a soft, balanced mouthfeel that complements food and wine." },
  { t: "Transparency first", d: "Every batch is intended to be tested and documented, with results shared openly with partners." },
];

export const Alkaline = () => (
  <section id="water" data-testid="alkaline-section" className="relative overflow-hidden bg-[#EDE1CA] py-24 sm:py-32">
    <span aria-hidden="true" className="font-serif-lux pointer-events-none absolute -right-6 top-6 select-none text-[14rem] italic leading-none text-[#B18A4A]/10 sm:text-[22rem]">pH</span>
    <div className="relative mx-auto grid max-w-[1440px] gap-16 px-5 sm:px-8 lg:grid-cols-[1.1fr_1fr] lg:items-center lg:px-12">
      <Reveal>
        <Eyebrow>The Alkaline Story</Eyebrow>
        <h2 className="h-section mt-6"><span className="block">Balanced by Design.</span><span className="block italic text-[#8C6A3C]">Verified Before Served.</span></h2>
        <p className="body-lux mt-8 max-w-lg !text-[#5f584f]">
          TOYAM Alkaline Water is being developed for guests who notice the details. We believe wellbeing begins
          with honesty — so every figure on our label will come from accredited testing, never from marketing.
        </p>
        <p className="mt-6 max-w-lg text-xs leading-relaxed text-[#746D64]">
          TOYAM makes no medical or therapeutic claims. pH and mineral content will be published only after accredited laboratory testing.
        </p>
      </Reveal>
      <Stagger className="space-y-8">
        {PILLARS.map((p, i) => (
          <StaggerItem key={p.t} className="flex gap-6 border-t border-[#B18A4A]/40 pt-6">
            <span className="font-serif-lux text-2xl leading-none text-[#B18A4A]">0{i + 1}</span>
            <div>
              <h3 className="font-sans text-[11px] font-bold uppercase tracking-[0.22em] text-[#26231F]">{p.t}</h3>
              <p className="mt-2 text-[14px] leading-relaxed text-[#5f584f]">{p.d}</p>
            </div>
          </StaggerItem>
        ))}
      </Stagger>
    </div>
    <LabResults />
  </section>
);
